import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ApplicationLinkCreationResponse } from './CommonApplicationLinkCreationEntity.tsx';

export const putApplinkProvider = (
	id: string,
	provider: string,
): Promise<ApplicationLinkCreationResponse> =>
	fetchJson(`/rest/applinks/3.0/applicationlink/${id}/authentication/provider`, {
		method: 'PUT',
		body: JSON.stringify({
			config: {},
			provider,
		}),
		headers: {
			'Content-Type': 'application/json',
		},
	});
